var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanKycPend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#7B1FA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23438 3.11703C5.23438 2.86564 5.34636 2.6691 5.53301 2.59597C5.69632 2.53198 6.29825 2.54569 6.4709 2.61425C6.57355 2.65996 6.66221 2.73766 6.70887 2.84279C6.78353 2.98905 6.77886 3.1216 6.64821 5.08698L6.5207 6.98551C6.51265 7.10531 6.46186 7.21824 6.37757 7.30375C6.11627 7.56885 5.67299 7.514 5.54234 7.19863C5.48168 7.06608 5.23438 3.73407 5.23438 3.11703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.965 8.07918C5.58658 8.07918 5.27981 8.38595 5.27981 8.76437C5.27981 9.14279 5.58658 9.44956 5.965 9.44956H5.99362C6.37204 9.44956 6.67881 9.14279 6.67881 8.76437C6.67881 8.38595 6.37204 8.07918 5.99362 8.07918H5.965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanKycPend);
export default __webpack_public_path__ + "static/media/loan_kyc_pend.2b92e640938f967d0530c1250e5cbf91.svg";
export { ForwardRef as ReactComponent };